module.exports = __webpack_public_path__ + "static/media/Female02.d965e9a1.jpg";